import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetContract = (studentId, keyStage) => {
    const {
        isLoading, data: contract, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: [`student/${studentId}/contracts`, keyStage],
        queryFn: () => axiosManager.get$(`/parent/api/students/${studentId}/contracts${keyStage ? `?keyStage=${keyStage}` : ""}`).then((response) => response?.data),
        retry: 0,
        cacheTime: 0,
        keepPreviousData: true,
        initialData: undefined,
        enabled: !!studentId,
    });

    return {
        isLoading,
        isRefetching,
        contract,
        error,
        refetch,
    };
};
